import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useLocation } from 'react-router-dom';
import { useAppStore } from '../../stores/useAppStore';
import { useAuthStore } from '../../stores/useAuthStore';

export function Logo() {
  return (
    <Link to="/" className="rx-logo" aria-label="RubExchange — на главную">
      <span className="rx-logo__mark" aria-hidden="true">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
          <path d="M5 8h11.5M5 8l3-3M19 16H7.5M19 16l-3 3" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      </span>
      <span>
        RubExchange
      </span>
    </Link>
  );
}

export function Header() {
  const { t } = useTranslation();
  const { settings, theme, toggleTheme } = useAppStore();
  const user = useAuthStore((s) => s.user);
  const token = useAuthStore((s) => s.token);
  const { pathname } = useLocation();
  const [scrolled, setScrolled] = useState(false);

  const botLink = settings['bot_link'] || '#';
  const supportLink = settings['support_link'] || '#';
  // На главной якоря работают без перезагрузки, с других страниц ведём на главную.
  const anchor = (id: string) => (pathname === '/' ? `#${id}` : `/#${id}`);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header className={'rx-header' + (scrolled ? ' rx-header--scrolled' : '')}>
      <div className="rx-header__inner">
        <Logo />

        <nav className="rx-nav" aria-label="Разделы">
          <a href={anchor('exchange')} className="rx-nav__link">Обмен</a>
          <a href={anchor('how')} className="rx-nav__link">Как это работает</a>
          <a href={anchor('faq')} className="rx-nav__link">FAQ</a>
          {supportLink !== '#' && (
            <a href={supportLink} target="_blank" rel="noopener noreferrer" className="rx-nav__link">
              Поддержка
            </a>
          )}
        </nav>

        <div className="rx-header__actions">
          <button
            type="button"
            className="rx-icon-btn"
            onClick={toggleTheme}
            aria-label={theme === 'light' ? 'Тёмная тема' : 'Светлая тема'}
            title={theme === 'light' ? 'Тёмная тема' : 'Светлая тема'}
          >
            {theme === 'light' ? (
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M21 12.8A9 9 0 1 1 11.2 3a7 7 0 0 0 9.8 9.8z" />
              </svg>
            ) : (
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
                <circle cx="12" cy="12" r="4.5" />
                <path d="M12 2v2M12 20v2M4.9 4.9l1.4 1.4M17.7 17.7l1.4 1.4M2 12h2M20 12h2M4.9 19.1l1.4-1.4M17.7 6.3l1.4-1.4" />
              </svg>
            )}
          </button>

          {botLink !== '#' && (
            <a
              href={botLink}
              target="_blank"
              rel="noopener noreferrer"
              className="rx-btn rx-btn--ghost rx-hide-sm"
            >
              {t('header.goToBot')}
            </a>
          )}

          {token && user ? (
            <Link to="/account" className="rx-btn rx-btn--primary">
              <span className="rx-header__user">{user.email || 'Кабинет'}</span>
              {!user.is_fully_verified && <span className="rx-dot-alert" aria-label="Нужна верификация" />}
            </Link>
          ) : (
            <>
              <Link to="/login" className="rx-btn rx-btn--ghost">
                Войти
              </Link>
              <Link to="/register" className="rx-btn rx-btn--primary rx-hide-sm">
                Регистрация
              </Link>
            </>
          )}
        </div>
      </div>
    </header>
  );
}
